import {useEffect} from 'react'
import {useAppDispatch} from '../../../common/store'
import {undo, redo} from '../../../common/undoable'

// ── Hook for Cmd+Z / Cmd+Shift+Z keyboard shortcuts ──────────────

const useUndoRedoShortcuts = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Use metaKey on Mac, ctrlKey on others
      const modifier = e.metaKey || e.ctrlKey
      if (!modifier) return

      if (e.key === 'z' && !e.shiftKey) {
        e.preventDefault()
        dispatch(undo())
      } else if ((e.key === 'z' && e.shiftKey) || e.key === 'y') {
        e.preventDefault()
        dispatch(redo())
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [dispatch])
}

export default useUndoRedoShortcuts
